import { ScrollableQueryResult } from 'hooks/use-scrollable-query';

type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};

export type ProductType = 'accounts' | 'items' | 'states' | 'stores';
export interface ProductsQueryOptionsArgs {
  productType: ProductType;
  defaultSortAttribute: string;
  defaultSearchAttribute: Array<string>;
  resultAttribute: string;
}

export interface ProductOptionContentParams {
  productType: ProductType;
  totalItems: number;
  queryResult: ScrollableQueryResult<any>;
  dataKeyMapper?: (row: any) => string;
  dataItemMapper?: (row: any) => ItemType;
}

export type ItemType = {
  id: string;
  label: string;
};

export type ProductSelection = PartialRecord<ProductType, Array<ItemType>>;

export const MENU_SECTIONS: Array<ProductType> = ['accounts', 'states', 'stores', 'items'];

export type CommonQueryFiltersType = {
  weeks: number;
  brand: string;
  clientID: string;
};

export type QueryFiltersType = ProductSelection & CommonQueryFiltersType;
